<i18n src="../../locales/lang.json"></i18n>

<template>
  <div class="container-fluid" v-bind:id="getId()" ref="container" style="height:100%;">
    <table border="0" style="height:100%; width:100%">
      <tr>
        <td valign="top" style="height: 100%;">
          <div v-bind:id="'messageTable' + threadid" style="display: block; width:100%;  height: 100%;position:relative; overflow:auto">
            <div style="display: block; position: absolute; width: 100%; ">
              <div style="width: 100%; padding: 0px; display: block;" valign="top">
                <discuss-recursive-message class="mb-1 p-0" style="padding:10px;" v-for="node in messageTree" v-bind:mode="viewmode" :islast="node.isLast" v-bind:unformattedlabel="node.unformattedlabel" :isadmin="node.isadmin" :nodes="node.nodes" :username="node.UserName" v-bind:issinglemessage="node.issinglemessage" :label="node.label" :messageid="node.messageid" :threadid="node.threadid" :dateandtime="node.dateandtime" :userabbreviation="node.userabbreviation" v-on:updatedthread="parentUpdatedthreadHandler"></discuss-recursive-message>
              </div>
            </div>
          </div>
        </td>
      </tr>
      <tr>
        <td style="height:40px;">
          <div class="row">
            <!--<div>
              <ul v-if="showOptions && filteredOptions.length > 0">
                <li v-for="(option, index) in filteredOptions" :key="option.id" @click="selectOption(index)">
                  {{ option.name }}
                </li>
              </ul>
            </div>-->

            <div class="col-12 main-msg-box" style="height:100%">
              <textarea ref="textarea" @input="handleInput" class="skin form-control messageinput" v-on:keyup.enter="reply" v-bind:placeholder="$t('enter_message')" v-model="message" v-bind:id="'messageinput' + threadid" style="float:left;"></textarea>
              <button type="button" class="btn skin primary-button" style="min-width:100px;float:right;" @click="reply">{{$t('post')}}</button>
            </div>
          </div>
        </td>
      </tr>
    </table>
    <common-ticker ref="ticker"></common-ticker>
    <!-- Options Popup -->
    <options-popup :options="filteredOptions"
                   :showOptions="showOptions && filteredOptions.length > 0"
                   :position="popupPosition" />
  </div>
</template>

<script>

  //import EmijiService from "../services/EmojiService";
  import discussRecursiveMessage from './discuss-recursive-message.vue'
  import OptionsPopup from './options-popup.vue'; // Adjust path as per your file structure
  //import emojiservice from "../services/EmojiService";
  var doScroll = true;
  var _threadId = -1;
  var message = "";
  let messageTree = [];
  var tmpdisplayState = {
  };


  export default {

    name: 'discuss-singlethread',
    components: {
      discussRecursiveMessage,
      OptionsPopup
    },
    props: {
      uid: {
        required: false,
        type: String,
        default: null
      },
      mode: {
        required: false,
        type: String,
        default: "tree"
      },
      threadtitle: {
        required: false,
        type: String,
        default: null
      },
      forumname: {
        required: false,
        type: String,
        default: null
      },
    },
    data() {
      return {
        reloadThread: null,
        message,
        _threadId,
        displayState: tmpdisplayState,
        messageTree,
        viewmode: this.mode,
        doScroll,
        //
        content: '',          // To store textarea content
        showOptions: false,   // To control when to show options
        users: [],
        tags: [],
        filteredOptions: [],  // To store filtered options based on input
        cursorPosition: 0,    // To store current cursor position in textarea
        textarea: null,
        popupPosition: { x: 0, y: 0 },  // Position of the popup
      };
    },


    methods: {
      //
      async loadTags() {
        try {
          this.$http.get('/api/Threads/v1/Site').then(async response => {

            if (response.data !== null && response.data.length > 0) {
              response.data = response.data.sort(function (a, b) {
                var x = a.toLowerCase();
                var y = b.toLowerCase();
                return x < y ? -1 : x > y ? 1 : 0;
              });
            }
            this.tags = [];
            for (var i = 0; i < response.data.length; i++) {
              this.tags.push({
                id: response.data[i], name: response.data[i]
              });
            }
            console.log(this.tags);
          });
        } catch (err) {
          alert('some error:' + err)
        }
      },
      async loadUsers() {
        try {
          this.$http.get('/api/Users/v1').then(async response => {
            this.users = [];

            if (response.data !== null && response.data.length > 0) {
              response.data = response.data.sort(function (a, b) {
                var x = a.Name.toLowerCase();
                var y = b.Name.toLowerCase();
                return x < y ? -1 : x > y ? 1 : 0;
              });
            }
            this.users = [];
            for (var i = 0; i < response.data.length; i++) {
              //if (i < 5) {
              this.users.push({
                id: response.data[i].UserName, name: response.data[i].Name
              });
              //}
            }
            //this.filterUsers();
          });
        } catch (err) {
          alert('some error:' + err)
        }
      },
      setPopupPosition(event) {
        // Get the position of the div relative to the viewport
        const rect = event.target.getBoundingClientRect();
        this.popupPosition = {
          x: 0,//rect.left,  // Example: X position based on mouse click event
          y: rect.top - 220,   // Example: Y position based on mouse click event
        };
      },
      handleInput(text) {
        // Get the selection range
        const selection = window.getSelection();
        var selectionStart = 0;

        if (selection.rangeCount > 0) {
          const range = selection.getRangeAt(0);
          // Now you can access selection start and end positions
          selectionStart = range.startOffset;
          const selectionEnd = range.endOffset;
        }

        //var m = $('#messageinput' + this.threadid).val();
        this.content = text;
        //alert(this.content);
        //const textarea = this.$el.querySelector('.emojionearea-editor');//this.$refs.textarea;
        const cursorPosition = selectionStart;//textarea.selectionStart;

        const contentBeforeCursor = this.content.substring(0, cursorPosition);

        // Check if "#" is typed and show options accordingly
        const lastWord = contentBeforeCursor.split(/\s+/).pop();
        if (lastWord && (lastWord.charAt(0) === '@' || lastWord.charAt(0) === '#')) {
          //alert($(this.textarea).data('emojioneArea').getText());
          const query = lastWord.substring(1).toLowerCase(); // Get the query after "#"

          if (lastWord.charAt(0) === '@') {
            this.filteredOptions = this.users.filter(option =>
              option.name.toLowerCase().includes(query)
            );
          } else {
            this.filteredOptions = this.tags.filter(option =>
              option.name.toLowerCase().includes(query)
            );
          }

          if (this.filteredOptions.length < 4) {
            this.popupPosition = {
              x: 0,//rect.left,  // Example: X position based on mouse click event
              y: this.popupPosition.y + (120 - (30 * this.filteredOptions.length)),   // Example: Y position based on mouse click event
            };
          }


          this.showOptions = true;
          // Attach click event listener to close popup when clicking outside
          document.addEventListener('click', this.onClickOutside);
          this.cursorPosition = cursorPosition; // Save cursor position for insertion
        } else {
          this.showOptions = false;
          // Remove click event listener when popup is hidden
          document.removeEventListener('click', this.onClickOutside);
        }
      },
      selectOption(index) {

        const contentBeforeCursor = this.content.substring(0, this.cursorPosition);

        // Check if "#" is typed and show options accordingly
        const lastWord = contentBeforeCursor.split(/\s+/).pop();
        let cursorPositionStart = this.cursorPosition;
        let cursorPositionEnd = this.cursorPosition;
        if (lastWord && (lastWord.charAt(0) === '@' || lastWord.charAt(0) === '#')) {
          const query = lastWord.substring(1).toLowerCase();
          if (query.length > 0) {
            cursorPositionStart = this.cursorPosition - query.length;
            cursorPositionEnd = this.cursorPosition + query.length;
          }
        }

        // Replace text after "#" with selected option
        const selectedOption = this.filteredOptions[index];
        const optionName = selectedOption.id + ' ';
        let start = cursorPositionStart; //- (this.content.split(/\s+/).pop().length) + 1;
        const end = cursorPositionEnd;
        const newText = this.content.substring(0, start) + optionName + this.content.substring(end);

        this.content = newText;
        this.showOptions = false;
        const textarea = this.textarea;
        $(textarea).html(newText);
        this.$nextTick(() => {
          // Set cursor position after inserted option
          const newCursorPosition = start + optionName.length;
          textarea.selectionStart = newCursorPosition;
          textarea.selectionEnd = newCursorPosition;
        });
        //this.$forceUpdate();
      },
      attachEventWithEditor() {
        // Example of selecting elements using querySelector
        const parentEl = this.$el.querySelector('.main-msg-box');
        const element = parentEl.querySelector('.emojionearea-editor');
        if (element) {
          //this.textarea = element;
          //element.style.color = 'red';
          element.addEventListener('input', this.handleInputChange);
          this.$forceUpdate();
        }
      },

      handleInputChange(event) {
        this.setPopupPosition(event);
        this.textarea = event.target;
        this.handleInput(event.target.innerText);
      },
      onClickOutside(event) {
        // Check if clicked element is outside the popup
        if (this.showOptions && this.filteredOptions.length > 0) {
          this.showOptions = false;
          // Remove event listener after closing popup
          document.removeEventListener('click', this.onClickOutside);
        }
      },
      //
      handleResize() {
        this.tryScrollToBottom();
      },

      getId() {
        return "container_" + this._uid;
      },
      async reply() {
        $('#messageinput' + this.threadid).val($(this.textarea).html());
        var m = $('#messageinput' + this.threadid).val();
        this.addMessage(m);
      },
      async addMessage(m) {


        if (m == "")
          return;

        var request = { AddReplyThreadId: this._threadId, message: m, AddReplyMessageId: -1, uid: this.uid, threadtitle: this.threadtitle, forumname: this.forumname };
        try {
          var response = await this.$http.post(
            '/api/Threads/v1/Reply',
            request
          ).then((response) => {
            if (this._threadId == -1 && response.data.ThreadId) {
              this._threadId = response.data.ThreadId;
            }

            this.doScroll = true;

            this.getThreadMessages(this._threadId);

            this.message = "";
            $('#messageinput' + this.threadid)[0].emojioneArea.setText("")

            this.$root.$emit("procedure_chat", this._threadId, m);
            this.loadTags();
            var thisContext = this;
            setTimeout(function () {
              var objDiv = document.getElementById("messageTable" + thisContext.threadid);
              if (objDiv != null)
                objDiv.scrollTop = objDiv.scrollHeight;
            }, 500)

          });
        } catch (err) {
          alert(err);
        }
      },
      async addMicroserviceMessage(m) {
        if (m == "")
          return;
        var request = { AddReplyThreadId: this._threadId, message: m, AddReplyMessageId: -1, uid: this.uid, threadtitle: this.threadtitle, forumname: this.forumname };
        try {
          var response = await this.$http.post(
            '/api/Forum/AddMicroserviceReply',
            request
          ).then((response) => {
            vm.$root.$emit('procedure_editor_can_close');
            if (this._threadId == -1 && response.data.ThreadId) {
              this._threadId = response.data.ThreadId;
            }
          });
        } catch (err) {
          alert(err);
        }
      },
      reload() {
        this.doScroll = true;
        if (this._threadId > -1) {
          this.getThreadMessages(this._threadId);
        }
        else if (this.uid != null) {
          this.getContextThread(this.uid);
        }

        var thisContext = this;
        setTimeout(function () {
          var objDiv = document.getElementById("messageTable" + thisContext.threadid);
          if (objDiv != null)
            objDiv.scrollTop = objDiv.scrollHeight;
        }, 100)

        /*
        $("#messageTable").animate({

          scrollTop: $("#messageTable").offset() + $("#messageTable").scrollHeight
        }, 2000);
        */

        var thisContext = this;

        /*
        if (this.reloadThread == null) {
          this.reloadThread = function () {
            setTimeout(function () {
              thisContext.reload();
              thisContext.reloadThread();
            }, 10000);
          };
          this.reloadThread();
        }
        */

      },

      getThreadMessages(threadid) {
        try {
          this.$http.get(`/api/Threads/v1/${threadid}?` + 'page=0').then(async response => {
            if (response.data != null && response.data.Threads) {
              Vue.set(this, "messageTree", this.makeMessageTree(response.data.Threads, -1))
            }
            else {
              this.messageTree = [];
            }



            this.$forceUpdate();
            setTimeout(function () {
              initOEmbed();
            }, 1000)


          });
        } catch (err) {
          alert('some error:' + err)
        }
      },
      getContextThread(uid) {
        try {
          this.uid = uid;
          this.$http.get('/api/Threads/v1/Uid/' + uid + '?page=0').then(async response => {

            if (response.data != null) {
              // Got the threadid from context
              if (response.data != null && typeof (response.data.ThreadId) != "undefined") {
                this._threadId = response.data.ThreadId;
                Vue.set(this, "messageTree", this.makeMessageTree(response.data.Threads, -1))
              }
              else {
                this._threadId = -1;
                Vue.set(this, "messageTree", [])
              }

              this.$root.$emit("procedure_viewchat", this._threadId);
            }
            else {
              // There is not thread created yet
              this.messageTree = [];
            }

            this.$forceUpdate();
            setTimeout(function () {
              initOEmbed();
            }, 1000)

          });
        } catch (err) {
          alert('some error:' + err)
        }
      },
      tryScrollToBottom() {
        var thisContext = this;
        if (thisContext.doScroll == true) {
          setTimeout(function () {
            thisContext.$refs.scroller.scrollTo(
              {
                y: "100%"
              },
              500
            );
            thisContext.doScroll = false;
          }, 1)
        }
        else {
        }
      },

      makeMessageTree(threads2, id) {
        var children = [];

        for (var i = 0; i < threads2.length; i++) {
          if (id == threads2[i].ParentId) {
            var childNode = {};
            childNode.isLast = false;
            childNode.label = this.emojiString(threads2[i].Content, childNode);
            childNode.unformattedlabel = threads2[i].Content;
            childNode.UserName = threads2[i].UserName;
            childNode.messageid = threads2[i].MessageId;
            childNode.isadmin = threads2[i].IsAdmin;
            childNode.threadid = this._threadId;
            if (threads2[i].DisplayTime != null)
              childNode.dateandtime = threads2[i].DisplayTime;
            if (threads2[i].DisplayDate != null)
              childNode.dateandtime += " " + threads2[i].DisplayDate;
            childNode.userabbreviation = threads2[i].UserAbbreviation
            childNode.nodes = this.makeMessageTree(threads2, threads2[i].MessageId);
            children.push(childNode);
          }

        }

        if (children.length > 0 && children.length > 1) {
          children[children.length - 1].isLast = true;
        }

        return children;
      },

      parentUpdatedthreadHandler(id) {
        this.getThreadMessages(this._threadId);
        //$('.emojionearealocked').each(function (i, d) {
        //  $(d).emoji();
        //});
      },
      setThreadId(id) {
        this._threadId = id;
        this.attachEventWithEditor();
      },
      emojiString(str, node) {

        if (str == null)
          return "";

        //var keys = '\\+1|-1|100|109|1234|8ball|a|ab|abc|abcd|accept|aerial_tramway|airplane|alarm_clock|alien|ambulance|anchor|angel|anger|angry|anguished|ant|apple|aquarius|aries|arrow_backward|arrow_double_down|arrow_double_up|arrow_down|arrow_down_small|arrow_forward|arrow_heading_down|arrow_heading_up|arrow_left|arrow_lower_left|arrow_lower_right|arrow_right|arrow_right_hook|arrow_up|arrow_up_down|arrow_up_small|arrow_upper_left|arrow_upper_right|arrows_clockwise|arrows_counterclockwise|art|articulated_lorry|astonished|atm|b|baby|baby_bottle|baby_chick|baby_symbol|baggage_claim|balloon|ballot_box_with_check|bamboo|banana|bangbang|bank|bar_chart|barber|baseball|basketball|bath|bathtub|battery|bear|bee|beer|beers|beetle|beginner|bell|bento|bicyclist|bike|bikini|bird|birthday|black_circle|black_joker|black_nib|black_square|black_square_button|blossom|blowfish|blue_book|blue_car|blue_heart|blush|boar|boat|bomb|book|bookmark|bookmark_tabs|books|boom|boot|bouquet|bow|bowling|bowtie|boy|bread|bride_with_veil|bridge_at_night|briefcase|broken_heart|bug|bulb|bullettrain_front|bullettrain_side|bus|busstop|bust_in_silhouette|busts_in_silhouette|cactus|cake|calendar|calling|camel|camera|cancer|candy|capital_abcd|capricorn|car|card_index|carousel_horse|cat|cat2|cd|chart|chart_with_downwards_trend|chart_with_upwards_trend|checkered_flag|cherries|cherry_blossom|chestnut|chicken|children_crossing|chocolate_bar|christmas_tree|church|cinema|circus_tent|city_sunrise|city_sunset|cl|clap|clapper|clipboard|clock1|clock10|clock1030|clock11|clock1130|clock12|clock1230|clock130|clock2|clock230|clock3|clock330|clock4|clock430|clock5|clock530|clock6|clock630|clock7|clock730|clock8|clock830|clock9|clock930|closed_book|closed_lock_with_key|closed_umbrella|cloud|clubs|cn|cocktail|coffee|cold_sweat|collision|computer|confetti_ball|confounded|confused|congratulations|construction|construction_worker|convenience_store|cookie|cool|cop|copyright|corn|couple|couple_with_heart|couplekiss|cow|cow2|credit_card|crocodile|crossed_flags|crown|cry|crying_cat_face|crystal_ball|cupid|curly_loop|currency_exchange|curry|custard|customs|cyclone|dancer|dancers|dango|dart|dash|date|de|deciduous_tree|department_store|diamond_shape_with_a_dot_inside|diamonds|disappointed|dizzy|dizzy_face|do_not_litter|dog|dog2|dollar|dolls|dolphin|door|doughnut|dragon|dragon_face|dress|dromedary_camel|droplet|dvd|e-mail|ear|ear_of_rice|earth_africa|earth_americas|earth_asia|egg|eggplant|eight|eight_pointed_black_star|eight_spoked_asterisk|electric_plug|elephant|email|end|envelope|es|euro|european_castle|european_post_office|evergreen_tree|exclamation|expressionless|eyeglasses|eyes|facepunch|factory|fallen_leaf|family|fast_forward|fax|fearful|feelsgood|feet|ferris_wheel|file_folder|finnadie|fire|fire_engine|fireworks|first_quarter_moon|first_quarter_moon_with_face|fish|fish_cake|fishing_pole_and_fish|fist|five|flags|flashlight|floppy_disk|flower_playing_cards|flushed|foggy|football|fork_and_knife|fountain|four|four_leaf_clover|fr|free|fried_shrimp|fries|frog|frowning|fuelpump|full_moon|full_moon_with_face|game_die|gb|gem|gemini|ghost|gift|gift_heart|girl|globe_with_meridians|goat|goberserk|godmode|golf|grapes|green_apple|green_book|green_heart|grey_exclamation|grey_question|grimacing|grin|grinning|guardsman|guitar|gun|haircut|hamburger|hammer|hamster|hand|handbag|hankey|hash|hatched_chick|hatching_chick|headphones|hear_no_evil|heart|heart_decoration|heart_eyes|heart_eyes_cat|heartbeat|heartpulse|hearts|heavy_check_mark|heavy_division_sign|heavy_dollar_sign|heavy_exclamation_mark|heavy_minus_sign|heavy_multiplication_x|heavy_plus_sign|helicopter|herb|hibiscus|high_brightness|high_heel|hocho|honey_pot|honeybee|horse|horse_racing|hospital|hotel|hotsprings|hourglass|hourglass_flowing_sand|house|house_with_garden|hurtrealbad|hushed|ice_cream|icecream|id|ideograph_advantage|imp|inbox_tray|incoming_envelope|information_desk_person|information_source|innocent|interrobang|iphone|it|izakaya_lantern|jack_o_lantern|japan|japanese_castle|japanese_goblin|japanese_ogre|jeans|joy|joy_cat|jp|key|keycap_ten|kimono|kiss|kissing|kissing_cat|kissing_closed_eyes|kissing_face|kissing_heart|kissing_smiling_eyes|koala|koko|kr|large_blue_circle|large_blue_diamond|large_orange_diamond|last_quarter_moon|last_quarter_moon_with_face|laughing|leaves|ledger|left_luggage|left_right_arrow|leftwards_arrow_with_hook|lemon|leo|leopard|libra|light_rail|link|lips|lipstick|lock|lock_with_ink_pen|lollipop|loop|loudspeaker|love_hotel|love_letter|low_brightness|m|mag|mag_right|mahjong|mailbox|mailbox_closed|mailbox_with_mail|mailbox_with_no_mail|man|man_with_gua_pi_mao|man_with_turban|mans_shoe|maple_leaf|mask|massage|meat_on_bone|mega|melon|memo|mens|metal|metro|microphone|microscope|milky_way|minibus|minidisc|mobile_phone_off|money_with_wings|moneybag|monkey|monkey_face|monorail|moon|mortar_board|mount_fuji|mountain_bicyclist|mountain_cableway|mountain_railway|mouse|mouse2|movie_camera|moyai|muscle|mushroom|musical_keyboard|musical_note|musical_score|mute|nail_care|name_badge|neckbeard|necktie|negative_squared_cross_mark|neutral_face|new|new_moon|new_moon_with_face|newspaper|ng|nine|no_bell|no_bicycles|no_entry|no_entry_sign|no_good|no_mobile_phones|no_mouth|no_pedestrians|no_smoking|non-potable_water|nose|notebook|notebook_with_decorative_cover|notes|nut_and_bolt|o|o2|ocean|octocat|octopus|oden|office|ok|ok_hand|ok_woman|older_man|older_woman|on|oncoming_automobile|oncoming_bus|oncoming_police_car|oncoming_taxi|one|open_file_folder|open_hands|open_mouth|ophiuchus|orange_book|outbox_tray|ox|page_facing_up|page_with_curl|pager|palm_tree|panda_face|paperclip|parking|part_alternation_mark|partly_sunny|passport_control|paw_prints|peach|pear|pencil|pencil2|penguin|pensive|performing_arts|persevere|person_frowning|person_with_blond_hair|person_with_pouting_face|phone|pig|pig2|pig_nose|pill|pineapple|pisces|pizza|plus1|point_down|point_left|point_right|point_up|point_up_2|police_car|poodle|poop|post_office|postal_horn|postbox|potable_water|pouch|poultry_leg|pound|pouting_cat|pray|princess|punch|purple_heart|purse|pushpin|put_litter_in_its_place|question|rabbit|rabbit2|racehorse|radio|radio_button|rage|rage1|rage2|rage3|rage4|railway_car|rainbow|raised_hand|raised_hands|ram|ramen|rat|recycle|red_car|red_circle|registered|relaxed|relieved|repeat|repeat_one|restroom|revolving_hearts|rewind|ribbon|rice|rice_ball|rice_cracker|rice_scene|ring|rocket|roller_coaster|rooster|rose|rotating_light|round_pushpin|rowboat|ru|rugby_football|runner|running|running_shirt_with_sash|sa|sagittarius|sailboat|sake|sandal|santa|satellite|satisfied|saxophone|school|school_satchel|scissors|scorpius|scream|scream_cat|scroll|seat|secret|see_no_evil|seedling|seven|shaved_ice|sheep|shell|ship|shipit|shirt|shit|shoe|shower|signal_strength|six|six_pointed_star|ski|skull|sleeping|sleepy|slot_machine|small_blue_diamond|small_orange_diamond|small_red_triangle|small_red_triangle_down|smile|smile_cat|smiley|smiley_cat|smiling_imp|smirk|smirk_cat|smoking|snail|snake|snowboarder|snowflake|snowman|sob|soccer|soon|sos|sound|space_invader|spades|spaghetti|sparkler|sparkles|sparkling_heart|speak_no_evil|speaker|speech_balloon|speedboat|squirrel|star|star2|stars|station|statue_of_liberty|steam_locomotive|stew|straight_ruler|strawberry|stuck_out_tongue|stuck_out_tongue_closed_eyes|stuck_out_tongue_winking_eye|sun_with_face|sunflower|sunglasses|sunny|sunrise|sunrise_over_mountains|surfer|sushi|suspect|suspension_railway|sweat|sweat_drops|sweat_smile|sweet_potato|swimmer|symbols|syringe|tada|tanabata_tree|tangerine|taurus|taxi|tea|telephone|telephone_receiver|telescope|tennis|tent|thought_balloon|three|thumbsdown|thumbsup|ticket|tiger|tiger2|tired_face|tm|toilet|tokyo_tower|tomato|tongue|top|tophat|tractor|traffic_light|train|train2|tram|triangular_flag_on_post|triangular_ruler|trident|triumph|trolleybus|trollface|trophy|tropical_drink|tropical_fish|truck|trumpet|tshirt|tulip|turtle|tv|twisted_rightwards_arrows|two|two_hearts|two_men_holding_hands|two_women_holding_hands|u5272|u5408|u55b6|u6307|u6708|u6709|u6e80|u7121|u7533|u7981|u7a7a|uk|umbrella|unamused|underage|unlock|up|us|v|vertical_traffic_light|vhs|vibration_mode|video_camera|video_game|violin|virgo|volcano|vs|walking|waning_crescent_moon|waning_gibbous_moon|warning|watch|water_buffalo|watermelon|wave|wavy_dash|waxing_crescent_moon|waxing_gibbous_moon|wc|weary|wedding|whale|whale2|wheelchair|white_check_mark|white_circle|white_flower|white_square|white_square_button|wind_chime|wine_glass|wink|wink2|wolf|woman|womans_clothes|womans_hat|womens|worried|wrench|x|yellow_heart|yen|yum|zap|zero|zzz|orange_heart|rofl|slight_smile|upside_down|crazy_face|star_struck|money_mouth|hugging|nerd|cowboy|face_with_raised_eyebrow|face_with_monocle|slight_frown|face_with_symbols_over_mouth';

        var keys = '';

        var animations = '\\abe|access|angel|airplane|alarm_clock|alien|anger|angry|astonished|bandit|beer|bell|bertlett|bhangra|bike|bing|birthday|blackwidow|blush|bollylove|bomb|boom|bow|bowled|brb|bug|broken_heart|bulb|cake|call|camera|canyoutalk|car|cat|captain|chai|champagne|chappal|cheese|christmas_tree|clap|clapper|confetti_ball|clock|coffee|crown|cry|crying_cat_face|computer|computerrage|confidential|cool|cwl|coutinho10|dance|devil|dhakkan|discodancer|disgust|diya|dizzy_face|dog|doh|donkey|donttalktome|drink|drunk|dull|eg|emo|envy|evilgrin|excel|eyes|facepalm|finger|fear|fingerscrossed|fistbump|fireworks|fish|fishing_pole_and_fish|fist|flushed|flower|frog|frowning|footballfail|fubar|ghost|gift|giggle|golmaal|goodluck|gottorun|grimacing|grin|grinning|hamburger|handshake|handsinair|hanukkah|happy|headbang|headphones|heart|heart_eyes|heartbeat|heartpulse|hearts|heidi|henderson14|hi|highfive|holdon|holidayspirit|hollest|helicopter|hug|horse|hushed|hungover|idea|inlove|internetexplorer|island|joy|kaanpakadna|kangaroo|key|kiss|kissing_face|klopp|kya|laugh|laughing|learn|letsmeet|lips|lipssealed|listening|man|mlt|mmm|microsoft|mail|makeup|monkey|mooning|movie|muscle|music|muscleman|movember|nahi|nazar|neil|nerdy|nickfury|ninja|no|nod|naturescall|notes|ok|oliver|onedrive|onenote|ontheloo|outlook|oye|party|penguin|pig|poop|phone|pizza|plane|poke|polarbear|poolparty|powerpoint|praying|priidu|prohibed|promise|publisher|puke|pullshot|pumpkin|punch|rain|rainbow|raindeer|rabbit|rocket|roller_coaster|rock|runner|rofl|sad|sadness|santa|santamooning|sarcastic|shake|sharepoint|sheep|shielddeflect|shivering|shopping|skipping|skull|skype|skypebiz|slap|sleepy|smile|smirk|smoke|snowangel|speechless|star|stop|sturridge15|surprised|snail|suryannamaskar|swear|sweat|sunny|sunrise|talk|talktothehand|tandoorichicken|taur|think|time|tired_face|tmi|toivo|tongueout|tubelight|tumbleweed|turkey|umbrella|vampire|wait|waiting|wfh|whatsgoingon|whistle|woman|wink|win10|whew|wasntme|wonder|word|worry|xmastree|xbox|wtf|victory|violin|volcano|yawn|yes|yoga|zany|zombie|zipper';
        //var animations = '\\airplane|alarm_clock|alien|anger|angry|astonished|birthday|blush|bomb|boom|bug|bulb|camera|christmas_tree|clap|clapper|confetti_ball|crown|cry|crying_cat_face|disappointed|dizzy_face|eyes|fireworks|fish|fishing_pole_and_fish|fist|flushed|frog|frowning|ghost|grimacing|grin|grinning|hamburger|heart|heart_eyes|heartbeat|heartpulse|hearts|helicopter|horse|hushed|kiss|kissing_face|laughing|lips|notes|penguin|pig|poop|rabbit|rocket|roller_coaster|runner|sunny|sunrise|tired_face|volcano|';
        var animationRegex = new RegExp(':(' + animations + '):', 'g');
        var regex = new RegExp(':(' + keys + '):', 'g');
        // Row breaks should be visible in html
        str = str.replace(/(?:\r\n|\r|\n)/g, '<br>');
        var tmpStr = str.replace(/:/g, '');
        node.issinglemessage = false;
        if (typeof (keys.includes) != 'undefined' && animations.includes(tmpStr)) {
          // Animation, make it bigger
          node.issinglemessage = true;
          return str.replace(animationRegex, this.emojiReplaceAnimationBig);
        }
        else if (typeof (keys.includes) != 'undefined' && keys.includes(tmpStr)) {
          // Just a single icon, make it bigger
          node.issinglemessage = true;
          return str.replace(regex, this.emojiReplaceBig);
        }
        else {
          //str = str.replace(animationRegex, this.emojiReplaceAnimation);
          return str.replace(regex, this.emojiReplace);
        }

      },
      emojiReplaceAnimationBig() {
        var key = arguments[1];
        //var url = 'https://github.com/SCRAPTURE/jquery-emoji/raw/master/images/emojis';
        var url = '/images/emoji/animations';
        var extension = '.gif';
        var src = url + '/' + key + extension;
        return '<img class="emoji" width="60" height="60" align="absmiddle" src="' + src + '" alt="' + key + '" title="' + key + '" />';
      },
      emojiReplaceBig() {
        var key = arguments[1];
        //key = key.replace("_", "-");
        //var url = '/images/emoji/static';
        var url = '/images/emojis';
        var extension = '.png';
        var src = url + '/' + key + extension;
        return '<img class="emoji" width="60" height="60" align="absmiddle" src="' + src + '" alt="' + key + '" title="' + key + '" />';
      },
      emojiReplaceAnimation() {
        var key = arguments[1];
        //var url = 'https://github.com/SCRAPTURE/jquery-emoji/raw/master/images/emojis';
        var url = '/images/emoji/animations';
        var extension = '.gif';
        var src = url + '/' + key + extension;
        return '<img style="margin-top:-2px;" class="emoji" width="27" height="27" align="absmiddle" src="' + src + '" alt="' + key + '" title="' + key + '" />';
      },
      emojiReplace() {
        var key = arguments[1];
        //key = key.replace("_", "-");
        var url = 'https://cdn.jsdelivr.net/emojione/assets/3.1/png/32';
        //var url = '/images/emoji/static';

        var extension = '.png';
        var src = url + '/' + key + extension;
        return '<img class="emoji" width="20" height="20" align="absmiddle" src="' + src + '" alt="' + key + '" title="' + key + '" />';
      }
    },
    mounted() {
      var currentContext = this;
      this.loadUsers();
      this.loadTags();
      this.$refs.ticker.start(this.$refs.container.getAttribute('id'));
      this.reload();
      this.$refs.ticker.end(this.$refs.container.getAttribute('id'));

      if (this.mode != "flat") {
        this.$root.$emit('nux', this.$t('nux_discussion_detail'));
      }

      $('.messageinput').each(function (i, d) {

        var el = $(d).emojioneArea(
          {
            tones: true,
          });
        el[0].emojioneArea.on("emojibtn.click", function (button, event) {
          //currentContext.textarea = event.target;
          //currentContext.content = $(event.target).data('emojioneArea').getText();
          currentContext.textarea.innerHTML = $(currentContext.textarea).data('emojioneArea').getText();
          $(currentContext.textarea).data('emojioneArea').setFocus();
        });
        el[0].emojioneArea.on("focus", function (editor, event) {
          currentContext.textarea = event.target;
          currentContext.content = $(event.target).data('emojioneArea').getText();
          event.target.innerHTML = $(event.target).data('emojioneArea').getText();

          //// Get the selection range
          //const selection = window.getSelection();
          //var selectionStart = 0;
          //if (selection.rangeCount > 0) {
          //  const range = selection.getRangeAt(0);
          //  // Now you can access selection start and end positions
          //  selectionStart = range.startOffset;
          //}
          //console.log("selectionStart=" + selectionStart);
        });


      });

    },

    computed: {

      getBottomPadding: {
        get() {
          if (this.$store.getHelptextVisible()) {
            return "padding-bottom:80px;"
          }
          return "padding-bottom:0px;"
        },
      },
      getHeight: {
        get() {

          var otherHeight = 105;
          if (this.$store.isMobile())
            otherHeight = 140;
          if (this.$store.getHelptextVisible())
            otherHeight += 80;
          if (this.$store.getMenuVisible())
            otherHeight += 65;
          var height = window.innerHeight;
          height = height - otherHeight;
          return "height: " + height + "px;"
        },
      }
    },

    created: function () {
      //alert(EmijiService.getKeyWords());
    },

    updated() {
      $('.emojionearealocked').each(function (i, d) {
        //$(d).emoji();
        // $(d).emojioneArea();
      });
    },


  }

</script>
<style>
  .emoji {
    vertical-align: top;
  }

  .messageinput {
    width: calc(100% - 110px) !important;
    float: left !important;
    height: 100% !important;
  }

  .emojionearea-picker {
    right: initial !important;
    left: 0px;
  }

  .emojionearea-editor {
    min-height: 38px !important;
  }

  .chat-textbox {
    margin-bottom: 10px;
    position: relative; /* Ensure relative positioning for absolute children */
  }

  .emojionearealocked img {
    width: 20px;
    height: 20px;
  }
</style>

<style scoped>
  .emoji {
    vertical-align: top;
  }

  .messageinput {
    width: calc(100% - 110px) !important;
    float: left !important;
    height: 38px !important;
  }

  .discuss-thread-container {
    padding-bottom: 25px;
  }

  .discuss-thread-container {
    /*overflow:auto;
      height:calc(-210px + 100vh)*/
  }



  .chat-input-controls {
    /*position: absolute;*/
    margin-bottom: 10px;
    width: 100%;
    /*width: calc(-20px + 100%) !important;*/
  }

  @media (max-width: 768px) {
    .chat-input-controls {
      margin-bottom: 20px;
      /*width: calc(-50px + 100%);*/
    }
  }
</style>



// WEBPACK FOOTER //
// src/components/discuss/discuss-singlethread.vue